import { forwardRef } from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";

import {
  SCROLL_AREA_DEFAULTS,
  SCROLL_AREA_HORIZONTAL_ROOT_CLASS,
  SCROLL_AREA_ROOT_CLASS,
  SCROLL_AREA_VIEWPORT_CLASS,
  type TScrollAreaElement,
  type TScrollAreaProps,
} from "@/ui/components/primitives/ScrollArea/ScrollArea.config";
import { ScrollBar } from "@/ui/components/primitives/ScrollArea/ScrollBar";
import { cn } from "@/ui/lib/utils";

export const ScrollArea = forwardRef<TScrollAreaElement, TScrollAreaProps>(
  (
    {
      className,
      children,
      orientation = SCROLL_AREA_DEFAULTS.orientation,
      ...props
    },
    ref,
  ) => {
    const showVertical = orientation === "vertical" || orientation === "both";
    const showHorizontal = orientation === "horizontal" || orientation === "both";

    return (
      <ScrollAreaPrimitive.Root
        ref={ref}
        data-component="ScrollArea"
        className={cn(
          SCROLL_AREA_ROOT_CLASS,
          showHorizontal && SCROLL_AREA_HORIZONTAL_ROOT_CLASS,
          className,
        )}
        {...props}
      >
        <ScrollAreaPrimitive.Viewport
          data-component="ScrollAreaViewport"
          className={SCROLL_AREA_VIEWPORT_CLASS}
        >
          { children }
        </ScrollAreaPrimitive.Viewport>
        { showVertical ? <ScrollBar orientation="vertical" /> : null }
        { showHorizontal ? <ScrollBar orientation="horizontal" /> : null }
        <ScrollAreaPrimitive.Corner data-component="ScrollAreaCorner" />
      </ScrollAreaPrimitive.Root>
    );
  },
);

ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
